<template>
    <div>
    <mw-dialog size="mini_mini" ref="unitDialog" title="选择单位" :footerButton="unitFooterButton" :close-on-click-modal="false">
      <mw-tree :url="unitTreeUrl" :defaultParams="defaultParams" :async="false" ref="unitTree" :selectNode="selectUnitId"></mw-tree>
     </mw-dialog>

    <mw-dialog size="mini_small" ref="roleDialog" title="选择角色" :footerButton="roleFooterButton"  :close-on-click-modal="false">
      <mw-tree :url="roleTreeUrl" :multipleLeaf="true" :checkNodes="checkRoleIds" :async="false" :expandedFirst="true"
               ref="roleTree" :multiple="true"></mw-tree>
    </mw-dialog>

    <mw-dialog size="large_large"  title="选择用户" ref="userDialog" :footerButton="userFooterButton" :close-on-click-modal="false">
      <loadMan ref="userChoose" :RAdminData="chooseUsers" :defaultParentId="defaultParentId"></loadMan>
    </mw-dialog>

    <el-form label-width="130px" :rules="rules" :model="group" ref="groupForm">
      <el-col :span="24">
        <el-form-item label="单位名称" ref="unitName">
          <el-input v-model="group.unitName" readonly></el-input>
          <el-button @click="showUnitDialog" :disabled="group.name === '默认角色'">选择</el-button>
        </el-form-item>

        <el-form-item prop="unitId" v-show="false">
          <el-input v-model="group.unitId"></el-input>
        </el-form-item>

        <el-form-item prop="code" v-show="false">
          <el-input v-model="group.code"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="角色名称" prop="name">
          <el-input v-model="group.name" :readonly="group.name === '默认角色' && group.id.length > 0"></el-input>
          <el-button @click="changeDefultRole(1)"  v-show="isShowDefultBtn=='1'">默认角色</el-button>
          <el-button @click="changeDefultRole(2)"  v-show="isShowDefultBtn=='2'">普通角色</el-button>
        </el-form-item>
        <el-form-item prop="id" v-show="false">
          <el-input v-model="group.id"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="身份权限" prop="postRoleNames">
          <el-input type="textarea" :rows="2"
                    v-model="group.postRoleNames" readonly >
          </el-input>
          <el-button @click="showRoleDialog">选择</el-button>
        </el-form-item>
        <el-form-item prop="postRoleIds" v-show="false">
          <el-input v-model="group.postRoleIds"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="文档权限" prop="docRoleNames">
          <el-input type="textarea" :rows="2"
                    v-model="group.docRoleNames" readonly >
          </el-input>
          <el-button @click="showRoleDialog">选择</el-button>
        </el-form-item>
        <el-form-item prop="docRoleIds" v-show="false">
          <el-input v-model="group.docRoleIds"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="流程权限" prop="flowRoleNames">
          <el-input type="textarea" :rows="2"
                    v-model="group.flowRoleNames" readonly >
          </el-input>
          <el-button @click="showRoleDialog">选择</el-button>
        </el-form-item>
        <el-form-item prop="flowRoleIds" v-show="false">
          <el-input v-model="group.flowRoleIds"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="24" v-show="group.name != '默认角色'">
        <el-form-item label="用户人员" prop="userNames">

          <el-input type="textarea" :rows="2" v-model="group.userNames" readonly>
          </el-input>
          <el-button @click="userChoose">选择</el-button>
        </el-form-item>
        <el-form-item prop="userDeptIdentityIds" v-show="false">
          <el-input v-model="group.userDeptIdentityIds"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="角色描述" prop="dec">
          <el-input v-model="group.dec"></el-input>
        </el-form-item>
      </el-col>

    </el-form>
  </div>
</template>

<script>
  import loadMan from "./loadManager.vue"
  import { mapGetters } from 'vuex';

  export default {
    components: {
      loadMan
    },
     props: {
        groupId:{
          type: String,
          default: ''
        },
        openDialog: {
          type: Boolean,
          default: false
        },
        deptInfo:{
          type: Object
        },
        showDefultBtn:{
          type: String,
          default: ''
        }
      },
      computed: {
        ...mapGetters([
          'userInfo',
          'expUser'
        ])
      },
    data() {

      let me = this;
      return {

        defaultParentId: '',
        firstTime : true,
        change: false,
        isShowDefultBtn:this.showDefultBtn,

        unitTreeUrl: this.mwUrl('/api/org/getUnitTreeContainSelf'),
        defaultParams:{deep:true,isContainSelf:true,parentId:""},
        roleTreeUrl: this.mwUrl('/api/org/listAllGroupedRole'),


        unitFooterButton: [
          {label: '取消', func: me.selectUnitCancel,type:'default'},
          {label: '确定', func: me.selectUnitSure}
        ],
        roleFooterButton: [
          {label: '取消', func: me.selectRoleCancel,type: 'default'},
          {label: '确定', func: me.selectRoleSure}
        ],

        userFooterButton: [
          {label: '取消', func: me.cancelSelectUser,type: 'default'},
          {label: '确定', func: me.selectUserSure}
        ],

        checkRoleIds: [],
        selectUnitId: '',

        rules: {
          name: [
            {required: true, message: '请输入名称', trigger: 'blur'},
          ]
        },
        chooseUsers: [],
        group: {
          id: '',
          code: '',
          dec: '',
          name: '',
          unitId: '',
          unitName: '',
          userDeptIdentityIds: '',
          departmentIds: '',
          userNames: '',
          roleIds: '',
          roleNames: '',
          postRoleNames:'',
          postRoleIds:'',
          docRoleNames:'',
          docRoleIds:'',
          flowRoleNames:'',
          flowRoleIds:''
        }

      }
    },
    mounted() {
     this.init();
     var isSysAdmin = this.isSysAdmin();
      if(this.userInfo.developer || isSysAdmin){
        this.defaultParams.parentId = this.userInfo.owner;
      }else{
        if(this.$store.getters.curUnit && this.$store.getters.curUnit.length > 0){
          this.defaultParams.parentId = this.$store.getters.curUnit[0].id;
        }
      }
    },

    methods: {

      init(){
         if(this.groupId){
            this.mwApi.org.getGroup(this.groupId).then(res => {
              if(res.result){
                this.mwUtil.applyCover(this.group, res.result);
              }else{
                this.mwMsg('查询失败');
              }
            })
          }else{
            this.group.code = this.deptInfo.code;
            this.group.unitId = this.deptInfo.unitId;
            this.group.unitName = this.deptInfo.unitName;
            this.setShowDefultBtn(this.deptInfo.unitId)
          }
      },

      //单位选择
      selectUnitSure() {
        let data = this.mwRef('unitTree').getSelected();
        if (!data) {
          this.mwMsg('warning', '请选择单位');
        } else {
          this.group.code = data.id;
          this.group.unitId = data.id;
          this.group.unitName = data.text;
          this.selectUnitCancel();
          this.setShowDefultBtn(data.id);
        }
      },
      selectUnitCancel() {
        this.mwRef('unitDialog').hide();
      },

      showUnitDialog() {
        let me = this;
        me.selectUnitId = me.group.unitId;
        this.mwRef('unitDialog').show();
      },
      isSysAdmin(){
        if(this.userInfo.roles && this.userInfo.roles.length>0){
          for(var i=0;i<this.userInfo.roles.length;i++){
            if(this.userInfo.roles[i].name=="系统管理员"){
              return true;
            }
          }
        }
        return false;
      },
      userChoose() {

       if(this.group.code){
        this.mwRef('userDialog').show();
        this.chooseUsers = [];
        if(!this.firstTime){
         this.mwRef('userChoose').refreshTree(true);
        }
        this.firstTime = false;
        this.defaultParentId = this.group.code;
        if (this.group.userNames) {
          let names = this.group.userNames.split(',');
          let ids = this.group.userDeptIdentityIds.split(',');
          for (let i = 0; i < names.length; i++) {
            this.chooseUsers.push({
              departmentId: ids[i],
              name: names[i],
              identityId: ids[i]
            })
          }
        }}else{
          this.mwMsg('请选择单位');
        }
      },

      cancelSelectUser(){
        this.mwRef('userDialog').hide();
      },

      //显示角色树
      showRoleDialog() {
        let me = this;
        me.checkRoleIds = []
        if (me.group.postRoleIds) {
          me.checkRoleIds =  me.checkRoleIds.concat(me.group.postRoleIds.split(','));
        } 
        if (me.group.docRoleIds) {
          me.checkRoleIds = me.checkRoleIds.concat(me.group.docRoleIds.split(','));
        } 
        if (me.group.flowRoleIds) {
          me.checkRoleIds = me.checkRoleIds.concat(me.group.flowRoleIds.split(','));
        } 
        this.mwRef('roleDialog').show();
      },

      //选择用户
      selectUserSure() {
        this.mwRef('userDialog').hide();
        this.group.userNames = '';
        this.group.userDeptIdentityIds = '';
        this.group.departmentIds= '';
        let data = this.mwRef('userChoose').getValue();
        let userNames = [];
        let userDeptIdentityIds = [];
        let departmentIds = [];
        data.forEach(d => {
          userNames.push(d.name);
          userDeptIdentityIds.push(d.identityId);
          departmentIds.push(d.departmentId);
        });

        this.group.userNames = userNames.join();
        this.group.userDeptIdentityIds = userDeptIdentityIds.join();
        this.group.departmentIds = departmentIds.join();

      },

      //选择权限
      selectRoleSure() {
        let postRoleIds = [], postRoleNames = [], docRoleIds = [], docRoleNames = [], flowRoleIds = [], flowRoleNames = [];
        this.mwRef('roleTree').getSelected().forEach(d => {
          if(d.type&&d.type=="1"){
            postRoleIds.push(d.id);
            postRoleNames.push(d.text);
          }else if(d.type&&d.type=="2"){
            docRoleIds.push(d.id);
            docRoleNames.push(d.text);
          }else if(d.type&&d.type=="3"){
            flowRoleIds.push(d.id);
            flowRoleNames.push(d.text);
          }
        });
        this.group.postRoleIds = postRoleIds.join();
        this.group.postRoleNames = postRoleNames.join();
        this.group.docRoleIds = docRoleIds.join();
        this.group.docRoleNames = docRoleNames.join();
        this.group.flowRoleIds = flowRoleIds.join();
        this.group.flowRoleNames = flowRoleNames.join();
        this.selectRoleCancel();
      },

      selectRoleCancel() {
        this.mwRef('roleDialog').hide()
      },

      // form验证
      valid(){
         let val=false;
         this.mwRef('groupForm').validate((valid => {
             val= valid;
         }));
        return val;
      },

      getValue(){
        return this.group;
      },
      resetFields() {
        this.mwRef('groupForm').resetFields();
      },
      changeDefultRole(type){
        if(type&&type=="1"){
          this.group.name='默认角色';
          this.isShowDefultBtn='2';
        }else{
          this.group.name='';
          this.isShowDefultBtn='1';
        }
      },
      setShowDefultBtn(unitid){  //如果存在默认角色，则不显示默认角色按钮
        var me = this;
        var params = {code:unitid,start:0,limit:2000};
        me.mwApi.org.listGroupPagingByAuthType(params).then(res => {
          me.isShowDefultBtn = 1;
          for(var y=0;y<res.result.length;y++){
            if(res.result[y].name=="默认角色"){
              me.isShowDefultBtn = 0;
            }
          }
        })
      }


    },
     watch: {
       openDialog(val) {
         if (val && !this.groupId) {
           this.init();
         }
       },
        groupId(val){
          this.init()
        },
        deptInfo(){
          this.init();
        }
     }


  }

</script>

<style scoped>
.el-input{
  width: 80%
}

.el-input, .el-textarea {
    width: 80%;
  }

</style>




// WEBPACK FOOTER //
// src/modules/index/views/systemSet/org/user/roleInf.vue